module.exports = __webpack_public_path__ + "img/bim (13).45b9d4e7.png";